import {useMemo} from 'react';

import {getBoolByLockStatus, getLockStatusByBool} from '@/consts/uam/lockUnlockTypes';
import {useDeviceSettingBase} from '@/containers/DevicesPage/components/DeviceSettings/hooks/useDeviceSettingBase';
import {useLockUnlockSettingContent} from '@/containers/DevicesPage/hooks/useSettingsContent';
import {selectDeviceLockStatus} from '@/state/selectors/deviceSettings';

export const useDeviceLock = () => {
    const content = useLockUnlockSettingContent();
    const {values} = content;

    const {uiValue: isDeviceLockedUI, onChange} = useDeviceSettingBase({
        selector: selectDeviceLockStatus,
        valueConverter: getBoolByLockStatus,
        uiValueConverter: (isLocked) => isLocked,
        content,
        autoSave: true, // Device lock saves immediately on change
    });

    const currentValue = useMemo(() => {
        return values?.find(
            (item) => item.value?.toLowerCase() === getLockStatusByBool(isDeviceLockedUI).toLowerCase()
        );
    }, [values, isDeviceLockedUI]);

    const handleToggle = () => onChange(!isDeviceLockedUI);

    return {
        content,
        isDeviceLocked: isDeviceLockedUI,
        onChange: handleToggle,
        currentValue,
    };
};
